var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdDap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 16.8868V13.1667C35 11.9707 34.076 11 32.9375 11H21.25H15.0625C13.924 11 13 11.9707 13 13.1667V34.8333C13 36.0293 13.924 37 15.0625 37H32.9375C34.076 37 35 36.0293 35 34.8333V27.9245",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.8667H29.5M19 22.0667H29.5",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H23.9",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8101 18.6124L37.1095 17.3122C37.3804 17.0413 37.7478 16.8891 38.1309 16.8891C38.514 16.8891 38.8814 17.0413 39.1523 17.3122C39.4231 17.5831 39.5753 17.9505 39.5753 18.3336C39.5753 18.7166 39.4231 19.084 39.1523 19.3549L28.0844 30.4228C27.6772 30.8298 27.175 31.1289 26.6232 31.2932L24.5551 31.9094L25.1713 29.8412C25.3355 29.2895 25.6347 28.7873 26.0417 28.3801L35.8109 18.6124H35.8101ZM35.8101 18.6124L37.842 20.6443L35.8101 18.6124Z",
    fill: "#EFF0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8101 18.6124L37.1095 17.3122C37.3804 17.0413 37.7478 16.8891 38.1309 16.8891C38.514 16.8891 38.8814 17.0413 39.1523 17.3122C39.4231 17.5831 39.5753 17.9505 39.5753 18.3336C39.5753 18.7166 39.4231 19.084 39.1523 19.3549L28.0844 30.4228C27.6772 30.8298 27.175 31.1289 26.6232 31.2932L24.5551 31.9094L25.1713 29.8412C25.3355 29.2895 25.6347 28.7873 26.0417 28.3801L35.8109 18.6124H35.8101ZM35.8101 18.6124L37.842 20.6443",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdDap);
export default __webpack_public_path__ + "static/media/sd-dap.13c00eb24d12ddb9fb00026697e682e0.svg";
export { ForwardRef as ReactComponent };